import {JsonObject, JsonProperty} from "json2typescript";

import {JsonPropertyEmpty} from "../../utils/json-util";
import {TemplateItemsWithItemIdOutput} from "./template-item";

@JsonObject("TemplateItemListOutput")
export class TemplateItemListOutput {
    @JsonProperty()
    public templateId: string = "";

    @JsonProperty("itemList", [TemplateItemsWithItemIdOutput])
    public itemList: TemplateItemsWithItemIdOutput[] = JsonPropertyEmpty;

    constructor(init?: Partial<TemplateItemListOutput>) {
        Object.assign(this, init);
    }
}
